import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import ScrollIndicator from "../Home/ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";

import RechercheErrorState from "./components/RechercheErrorState";
import RechercheFilters from "./components/RechercheFilters";
import RechercheInitialState from "./components/RechercheInitialState";
import RechercheResults from "./components/RechercheResults";
import RechercheSearchBox from "./components/RechercheSearchBox";
import RechercheSkeleton from "./components/RechercheSkeleton";

import { RECHERCHE_PAGE, SEARCH_MIN_LENGTH } from "./data/rechercheUiData";
import { useRecherchePage } from "./hooks/useRecherchePage";

export default function RecherchePage() {
  useScrollToTop();

  const {
    query,
    term,
    setTerm,

    loading,
    error,
    hasQuery,
    isTooShort,

    normalized,
    activeSection,
    setActiveSection,

    recentSearches,

    submitSearch,
    clearSearch,
    selectRecentSearch,
    clearRecent,
    retry,
  } = useRecherchePage();

  return (
    <>
      <PageHero
        title={RECHERCHE_PAGE.title}
        imageUrl={RECHERCHE_PAGE.heroImageUrl}
        crumbs={RECHERCHE_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={RECHERCHE_PAGE.eyebrow}
          title={RECHERCHE_PAGE.title}
          description={RECHERCHE_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Résultats
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : normalized.total}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              résultat{normalized.total > 1 ? "s" : ""} trouvé
              {normalized.total > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        <section className="mt-6">
          <RechercheSearchBox
            term={term}
            onTerm={setTerm}
            onSubmit={submitSearch}
            onClear={clearSearch}
            loading={loading}
          />
        </section>

        {isTooShort && (
          <div className="mt-4 rounded-3xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm font-semibold text-amber-800 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300">
            Saisissez au moins {SEARCH_MIN_LENGTH} caractères pour lancer la
            recherche.
          </div>
        )}

        <section className="mt-6 space-y-6">
          {!hasQuery && !loading && (
            <RechercheInitialState
              recentSearches={recentSearches}
              onRecent={selectRecentSearch}
              onClearRecent={clearRecent}
            />
          )}

          {error && <RechercheErrorState onRetry={retry} />}

          {hasQuery && !error && loading && <RechercheSkeleton />}

          {hasQuery && !error && !loading && (
            <>
              <RechercheFilters
                normalized={normalized}
                activeSection={activeSection}
                onSection={setActiveSection}
                query={query}
              />

              <RechercheResults
                groups={normalized.groups}
                total={normalized.total}
                query={query}
                activeSection={activeSection}
              />
            </>
          )}
        </section>
      </main>
    </>
  );
}